<template>
  <div id="listSports">
    <Breadcrumb />

    <v-row no-gutters>
      <v-col cols="12" :md="openEvent && !smAndDown ? 6 : 12">
        <v-card
          class="pb-1 mt-2 colorDominant"
          elevation="0"
          outlined
          :class="{
            'mr-1': openEvent && !smAndDown,
          }"
        >
          <ToolbarTabMarkets :type="'nextEvents'" />
          <v-progress-linear
            absolute
            indeterminate
            :active="loading"
          ></v-progress-linear>
          <Table :type="'nextEvents'" :data="data_events" />
          <div>
            <v-alert
              text
              dense
              type="warning"
              border="left"
              class="ma-4 mb-2"
              v-if="msg_error"
            >
              {{ msg_error }}
            </v-alert>
            <v-alert
              v-else-if="data_events.length === 0"
              text
              dense
              type="info"
              border="left"
              class="ma-4 mb-2"
            >
              {{ $t("loading") }}
            </v-alert>
          </div>
          <v-divider />
        </v-card>
      </v-col>

      <v-col v-if="openEvent && !smAndDown" md="6">
        <div class="mt-2 ml-1">
          <router-view />
        </div>
      </v-col>

      <template v-if="smAndDown">
        <v-dialog
          v-model="dialog"
          scrollable
          transition="fab-transition"
          color="colorDominant"
          content-class="v-dialog--fullscreen"
        >
          <v-toolbar absolute dense elevation="0" color="transparent">
            <v-btn
              @click="$router.go(-1)"
              depressed
              fab
              x-small
              color="rgba(255,255,255,0.20)"
            >
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <router-view />
        </v-dialog>
      </template>
    </v-row>
  </div>
</template>
<script>
import Table from "@/components/table/table";
import Breadcrumb from "@/components/Breadcrumb";
// import ToolbarTabMarkets from "@/components/ToolbarTabMarkets";
import ToolbarTabMarkets from "@/views/home/events/components/toolbar-markets";
import rulesOdds from "@/mixins/rulesOdds";

export default {
  name: "sports",
  mixins: [rulesOdds],
  components: {
    Table,
    ToolbarTabMarkets,
    Breadcrumb,
  },

  data: () => {
    return {
      data_events: [],
      openEvent: false,
      smAndDown: false,
      loading: false,
      dialog: false,
      league: [
        "UEFA",
        "Libertadores",
        "Estados Unidos",
        "UFC/Boxe",
        "Internacional",
      ],
      groupCountries: {
        Asia: [51, 135, 206, 47, 122],
        Oceania: [17, 18, 184],
        Africa: [239, 169, 73, 2, 255, 177, 178, 107, 108, 109, 8],
        Europa: [4, 81, 215, 132, 206, 124, 112, 198, 90],
        UEFA: [32644, 30444, 26283, 39860, 30216, 2901, 40752, 2905],
        Libertadores: [
          36153,
          27738,
          7242,
          4909,
          2647,
          340,
          341,
          342,
          343,
          344,
          345,
          346,
          347,
          348,
          363,
          367,
          370,
          374,
          390,
          18748,
          18929,
        ],
        "Estados Unidos": [
          64,
          361,
          465,
          2136,
          3830,
          6689,
          19199,
          34076,
          34225,
          34226,
        ],
        "Europa 2": [128, 129, 196, 24, 64, 68, 226, 244, 25, 242],
        "Europa 3": [18, 186, 32, 200, 79, 83, 89, 38, 116, 204, 181],
        "América do Sul": [
          14,
          30,
          35,
          50,
          56,
          76,
          105,
          106,
          192,
          193,
          228,
          246,
          250,
        ],
        "América do Sul2": [162, 63, 82, 44],
        "Oriente Médio": [13, 126, 127, 75, 45, 131, 136],
        "UFC/Boxe": [31720, 14896],

        "Serie A": [20913],
        "Seria B": [20917],
      },
      msg_error: "",
      fullUrl: null,
    };
  },
  // Verifica se exite um array pre definido em "groupCountries"
  // com a determinada categoria vinda da url
  // Caso não tenha é um torneio especifico.
  mounted() {
    const replacementsGroupCountries = {
      Asia: this.$t("asia"),
      Oceania: this.$t("oceania"),
      Europa: this.$t("europe"),
      Africa: this.$t("africa"),
      // Libertadores: this.$t("libertadores"),
      "Estados Unidos": this.$t("unitedStates"),
      "Europa 2": this.$t("europe2"),
      "Europa 3": this.$t("europe3"),
      "América do Sul": this.$t("southAmerica"),
      "América do Sul2": this.$t("southAmerica2"),
      "América do Sul3": this.$t("southAmerica"),
      "Oriente Médio": this.$t("middleEast"),
      "UFC/Boxe": this.$t("ufcBoxing"),
    };

    let replacedItems = Object.keys(this.groupCountries).map((key) => {
      const newKey = replacementsGroupCountries[key] || key;
      return { [newKey]: this.groupCountries[key] };
    });
    const itemsTranslate = replacedItems.reduce((a, b) =>
      Object.assign({}, a, b)
    );
    this.groupCountries = itemsTranslate;

    const { category } = this.$route.query;

    if (this.groupCountries[category] != undefined) {
      const group = this.groupCountries[category];
      let isLeague = this.league.some((item) => item == category);
      isLeague ? this.getLigues(group) : this.getCountries(group);
    } else {
      // console.log("aqui no else");
      // const { category } = this.$route.params;
      // console.log(this.$route.params);
      this.simpleTournament(category);
    }
    this.checkOpenEvent();

    this.fullUrl = this.$route;
  },

  watch: {
    $route(to, from) {
      this.dialog = false;
      if (!this.smAndDown) return; // Se for mobile
      if (from.params.tournament != undefined) return; // Se o torneio estiver setado, trava a execuçao do script
      const { category } = this.$route.query;
      const contry = this.groupCountries[category];
      let isLeague = this.league.some((item) => item == category);
      !isLeague && contry != undefined ? this.getCountries(contry) : null;
      isLeague && contry != undefined ? this.getLigues(contry) : null;
      this.checkOpenEvent();
    },

    "$route.query.category": function(val) {
      if (this.smAndDown) return; // Se for desktop
      if (this.groupCountries[val] != undefined) {
        const contry = this.groupCountries[val];
        let isLeague = this.league.some((item) => item == val);
        !isLeague ? this.getCountries(contry) : this.getLigues(contry);
      }
      this.checkOpenEvent();
    },

    "$route.query.tournament": function(val) {
      // console.log(val);
      if (this.smAndDown) return; // Se for desktop
      if (val == undefined) return;
      const { tournament } = this.$route.params;
      this.simpleTournament(tournament);
      this.checkOpenEvent();
    },
  },
  methods: {
    checkOpenEvent: function() {
      this.openEvent = this.$route.query.event ? true : false;
      this.smAndDown = this.$vuetify.breakpoint.smAndDown ? true : false;
      this.dialog = this.$route.query.event && this.smAndDown ? true : false;
    },

    getCountries: function(arrIds) {
      // console.log(arrIds);
      const arrContriesIds = arrIds.map((item) => ({
        categories: item,
      }));

      const contries = {
        domain: this.$domain(),
      };

      for (const [i, item] of arrContriesIds.entries()) {
        const key_odds = Object.keys(item);
        const val_odds = Object.values(item);

        for (let j = 0; j < val_odds.length; j++) {
          contries[`${key_odds[j]}[${i + 1}]`] = val_odds[j];
        }
      }

      if (arrIds.length == 1) {
        const bodyRequest = {
          id_sport: 6046,
          id_category: arrIds[0],
          domain: contries.domain,
        };

        this.request("/player/table/eventsByCategory", bodyRequest);
      } else {
        this.request("/player/table/listCountries", contries);
      }
    },

    getLigues: function(group) {
      const url = "/player/table/listTournaments";
      const arrLiguesIds = group.map((item) => ({
        tournaments: item,
      }));

      const objToSend = {
        domain: this.$domain(),
      };

      for (const [i, item] of arrLiguesIds.entries()) {
        const key_odds = Object.keys(item);
        const val_odds = Object.values(item);

        for (let j = 0; j < val_odds.length; j++) {
          objToSend[`${key_odds[j]}[${i + 1}]`] = val_odds[j];
        }
      }

      this.request(url, objToSend);
    },

    simpleTournament: function(tournament) {
      // console.log(tournament);
      const url = "/player/table/eventsByTournament";
      const data = {
        domain: this.$domain(),
        id_tournament: tournament,
      };
      this.request(url, data);
    },

    request: function(url, data) {
      this.loading = true;
      this.$axios
        .post(url, this.$formdata(data))
        .then(async (resp) => {
          if (this.$route.name === "countries") {
            const data = resp.data.sports[0].categories;
            await this.editDataSports(data);
            this.data_events = data;
          } else {
            const data = [resp.data];
            const eventsFiltredBySport = await this.editDataSports(data);
            this.data_events = data;
          }

          this.msg_error = false; // reset
        })
        .catch((error) => {
          this.data_events = [];
          this.msg_error = error.response.data.messages.error;
          const msg = this.msg_error;
          const color = "warning";
          this.$store.commit("setNotification", { msg, color });
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
